import React from 'react'
import { FormattedMessage } from 'react-intl'

export default [
    {
        title: <FormattedMessage id={'Sidebar.lists'} />,
        icon: 'bars',
        childrens: [
            {
                title: <FormattedMessage id={'Model.location.list'} />,
                path: '/model/location',
            },
            {
                title: <FormattedMessage id={'Model.driver.list'} />,
                path: '/model/driver',
            },
            {
                title: <FormattedMessage id={'Model.vehicle.list'} />,
                path: '/model/vehicle',
            },
            {
                title: <FormattedMessage id={'Model.vehicletype.list'} />,
                path: '/model/vehicletype',
            },
            {
                title: <FormattedMessage id={'Model.itemtype.list'} />,
                path: '/model/itemtype',
            },
            {
                title: <FormattedMessage id={'Model.rates.list'} />,
                path: '/model/rates',
            },
            {
                title: <FormattedMessage id={'Model.termsandconditions.list'} />,
                path: '/model/termsandconditions',
            },
        ],
    }
]


// WEBPACK FOOTER //
// ./src/containers/SideBar/menus/lists.js